// @flow

import React from 'react';
import ConfigComponent from '../config';
import { ConfigHeading } from './atoms';
import ConfigBuilderGroup from './configBuilderGroup.container';
import type { Props } from './types';

export default ({ group, step }: Props) => (
  <ConfigBuilderGroup id={group.id} step={step}>
    <ConfigHeading>{group.header}</ConfigHeading>

    {group.elements.map((component, index) => (
      <ConfigComponent
        key={index} // eslint-disable-line
        component={component}
      />
    ))}
  </ConfigBuilderGroup>
);
